import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e9c16a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id", "innerHTML"]
const _hoisted_4 = ["id"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["id"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_14 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "div-main",
    id: `category-card-div-main-${_ctx.categoryServiceType}`
  }, [
    _createElementVNode("div", {
      class: "div-heading",
      id: `category-card-div-heading-${_ctx.categoryServiceType}`
    }, [
      _createElementVNode("h3", {
        id: `category-service-heading-${_ctx.categoryServiceType}`,
        innerHTML: _ctx.heading
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2),
    _createElementVNode("div", {
      class: "div-content",
      id: `category-card-div-content-${_ctx.categoryServiceType}`
    }, [
      (_ctx.textBold)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            innerHTML: _ctx.textBold
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.text1 && _ctx.text1link && _ctx.text1b)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.text1) + " ", 1),
            (_ctx.getSelectedLanguage == 'sv')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "info-link",
                  href: "https://www.docrates.com/sv/cancerformer/brostcancer/diagnos-av-brostcancer/ultraljudsundersokning-av-brost-och-nalprov/",
                  target: "_blank",
                  innerHTML: _ctx.text1link
                }, null, 8, _hoisted_7))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "info-link",
                  href: "https://www.docrates.com/syopamuodot/rintasyopa/rintasyovan-diagnosointi/rintojen-ultraaanitutkimus-ja-neulanayte/",
                  target: "_blank",
                  innerHTML: _ctx.text1link
                }, null, 8, _hoisted_8)),
            _createTextVNode(" " + _toDisplayString(_ctx.text1b), 1)
          ]))
        : (_ctx.text1)
          ? (_openBlock(), _createElementBlock("p", {
              key: 2,
              innerHTML: _ctx.text1
            }, null, 8, _hoisted_9))
          : _createCommentVNode("", true),
      (_ctx.text2)
        ? (_openBlock(), _createElementBlock("p", {
            key: 3,
            innerHTML: _ctx.text2
          }, null, 8, _hoisted_10))
        : _createCommentVNode("", true),
      (_ctx.text3)
        ? (_openBlock(), _createElementBlock("p", {
            key: 4,
            innerHTML: _ctx.text3
          }, null, 8, _hoisted_11))
        : _createCommentVNode("", true)
    ], 8, _hoisted_4),
    _createElementVNode("div", {
      class: "div-bottom",
      id: `category-card-div-bottom-${_ctx.categoryServiceType}`
    }, [
      _hoisted_13,
      _createElementVNode("button", {
        id: `category-card-button-${_ctx.categoryServiceType}`,
        class: "buttonContinue",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectedService && _ctx.selectedService(...args)))
      }, _toDisplayString(_ctx.store.getters.translate("category-service-card-button")), 9, _hoisted_14)
    ], 8, _hoisted_12)
  ], 8, _hoisted_1))
}